import { Device } from "@capacitor/device";

export namespace Utils {
  export async function isWebAsync(): Promise<boolean> {
    const info = await Device.getInfo();

    return info.platform === "web";
  }
}
